import { useEffect } from 'react';

const Eveal = () => {
  useEffect(() => {
    // Redirect immediately to the external URL
    window.location.href = 'https://sendpush.io/reveal';
  }, []);

  // Show a loading message briefly before redirect
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#003a70]/5 to-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#003a70] mx-auto mb-4"></div>
        <p className="text-[#003a70] font-medium">Redirecting...</p>
      </div>
    </div>
  );
};

export default Eveal;